import { GoogleTagManagerId } from '@/components/GoogleTagManager'

export const googleTagManagerId: GoogleTagManagerId =
  (process.env.NEXT_PUBLIC_GOOGLE_TAG_MANAGER_ID as GoogleTagManagerId) || ''
